import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import { cn } from "../../lib/utils";

interface ConnectionStatusProps {
  isConnected: boolean;
}

export function ConnectionStatus({ isConnected }: ConnectionStatusProps) {
  const isOnline = useOnlineStatus();

  if (isOnline && isConnected) {
    return null; // Don't show anything when connected
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-4 py-2 text-sm animate-in fade-in slide-in-from-top duration-300",
        isOnline
          ? "bg-amber-50 text-amber-800 border-b border-amber-100"
          : "bg-red-50 text-red-800 border-b border-red-100"
      )}
    >
      {isOnline ? (
        <>
          <svg
            className="size-4 animate-spin"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span>Reconnecting...</span>
        </>
      ) : (
        <>
          <svg
            className="size-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
            />
          </svg>
          <span>You're offline. Messages will be sent when you reconnect.</span>
        </>
      )}
    </div>
  );
}



